import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from '../../../../../assist/src/app/_shared/services/base.service';
import { UserPersonDto, UserPersonListDto } from "../models/user-person";
import { ApprovalResultDto, CouplingResultDto } from "../models/coupling";

@Injectable({ providedIn: "root" })
export class UserPersonService extends BaseService<UserPersonDto, UserPersonListDto> {
  constructor(
    protected override http: HttpClient,
    @Inject("PUBLIC_BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "userPerson");
  }

  addToUser(memberOrPersonKey: string, organizationKey: string): Observable<CouplingResultDto> {
    const params = new HttpParams()
      .set("memberOrPersonKey", memberOrPersonKey)
      .set("organizationKey", organizationKey);
    return this.http.post<CouplingResultDto>(`${this.baseUrl}userPerson/add`, {}, { params });
  }

  approveCoupling(token: string): Observable<ApprovalResultDto> {
    const params = new HttpParams().set("token", token);
    return this.http.post<ApprovalResultDto>(`${this.baseUrl}userPerson/approveCoupling`, {}, { params });
  }

  rejectCoupling(token: string): Observable<ApprovalResultDto> {
    const params = new HttpParams().set("token", token);
    return this.http.post<ApprovalResultDto>(`${this.baseUrl}userPerson/rejectCoupling`, {}, { params });
  }
}
